<!--
 * @Author: cryi.liu
 * @Date: 2020-06-10 14:54:26
 * @LastEditTime: 2020-06-22 17:31:07
 * @Description: 添加题目选项模态框
-->
<template>
  <i-modal
    class="add-option-modal"
    :loading="modalLoading"
    :value="modalShow"
    title="新增选项"
    @on-visible-change="modalVisibleChanged"
    @on-ok="modalClickOk">
    <i-form
      v-if="modalShow"
      ref="addOptionForm"
      :model="formData" :rules="forDataValidate" :label-width="80">
      <i-form-item label="内容：" prop="content">
        <i-input v-model="formData.content" size="small" placeholder="输入选项内容" />
      </i-form-item>
      <!-- <i-form-item label="状态：" prop="correct">
        <i-radio-group v-model="formData.correct">
          <i-radio label="正确" size="small">正确</i-radio>
          <i-radio label="错误" size="small">错误</i-radio>
        </i-radio-group>
      </i-form-item> -->
    </i-form>
  </i-modal>
</template>

<script>
export default {
  name: 'AddOptionModal',
  props: {
    modalShow: { type: Boolean, required: true },
    libraryId: { type: String, required: true },
    options: { type: Array, required: true },
  },
  data() {
    return {
      formData: {
        content: '',
        // correct: '正确',
      },
      forDataValidate: {
        content: [
          { required: true, message: '选项内容不能为空', trigger: 'blur' },
        ],
        // correct: [
        //   { required: true, message: '需要设置选项内容状态', trigger: 'blur' },
        // ],
      },
      modalLoading: true,
    };
  },
  methods: {
    modalVisibleChanged(state) {
      if (!state) {
        this.formData = {
          content: '',
          // correct: '正确',
        };

        this.$emit('hide-modal');
      }
    },
    /**
     * 模态框确认处理函数
     */
    modalClickOk() {
      this.$refs.addOptionForm.validate((valid) => {
        if (valid) {
          const formData = JSON.parse(JSON.stringify(this.formData));
          const options = JSON.parse(JSON.stringify(this.options));

          // eslint-disable-next-line no-unused-expressions
          formData.correct === '正确' ? formData.correct = true : formData.correct = false;
          formData.selected = false;

          options.push(formData);

          this.requestAddOptionAndSetting(options);
        } else {
          this.modalLoading = false;

          this.$nextTick(() => {
            this.modalLoading = true;
          });
        }
      });
    },
    /**
     * 请求新增题目选项并设置
     */
    requestAddOptionAndSetting(options) {
      this.requestAddOption(options)
        .then(() => {
          this.$emit('repull-question-info');
          this.$emit('hide-modal');
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求新增题目
     */
    requestAddOption(options) {
      const params = {
        id: this.libraryId,
        options,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.librarySaveQuestion(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.add-option-modal {
  /deep/ .ivu-form-item-error-tip {
    font-size: 12px;
  }
}
</style>
